import { Tag, Tooltip } from "@chakra-ui/react";

interface InterestTagProps {
	label: string;
	additionalInfo?: string;
}

export const InterestTag = ({ label, additionalInfo }: InterestTagProps) => {
	return (
		<Tooltip hasArrow rounded="3" bg="brand.dark" label={additionalInfo}>
			<Tag
				rounded="3"
				bg="brand.light"
				cursor="default"
				color="brand.dark"
				border="solid 1.5px"
				borderColor="brand.dark"
				_hover={{ borderColor: "brand.contrast" }}
			>
				{label}
			</Tag>
		</Tooltip>
	);
};
